import { pick } from 'lodash';
import safeStringifyMod from 'json-stringify-safe';

export const safeStringify = (obj) => {
    let resultStr = '';

    try {
        resultStr = safeStringifyMod(obj);
    } catch (e) {
        resultStr = e.toString();
    }
    return resultStr;
};

export const safeStringifyAxios = (axiosResponse) => {
    const allowedKeys = ['data', 'status', 'statusText']; // we want to strip: 'headers', 'config', 'request'
    const safeAxiosResponse = pick(axiosResponse, allowedKeys);
    return safeStringify(safeAxiosResponse);
};
